<nav class="navbar navbar-expand-lg navbar-light bg-light primary">
    <span class="navbar-brand">
        <img src="../../assets/images/nesten-logo.png" alt="" class="img-fluid" style="height: 40px;">
    </span>
    <span class="headerSpace"></span>
    <span>
        <p *ngIf="this.helper.accountLoaded">Account : {{this.helper.accountList[this.helper.slectedAddress]}}</p>
    </span>
</nav>
<div class="main-div py-5">
    <div class="container">
        <div class="row justify-content-center">
            <div class="col-12">
                <h2 class="title">Import Wallet</h2>
                <div class="form-holder mb-4">
                    <div class="row justify-content-between">

                        <div class="col-md-8">
                            <mat-form-field class="example-full-width">
                                <input class="primary" matInput [(ngModel)]="seed" placeholder="Enter 12 Seed Words">
                            </mat-form-field>
                            <!-- <button mat-stroked-button class="primary border-gradient-btn mb-2">Import</button> -->
                            <mat-form-field class="example-full-width mt-4">
                                <input type="password" class="primary" [(ngModel)]="passPhrase" matInput placeholder="Set Wallet Access PIN">
                            </mat-form-field>
                            <mat-form-field class="example-full-width mt-4">
                              <input type="password" class="primary" [(ngModel)]="confirmPassPhrase" matInput placeholder="Confirm PIN">
                            </mat-form-field>
                        </div>
                        <div class="col-md-4">
                            <div class="gradient-box">
                                <div class="text-center">
                                    <img src="../../assets/images/exclamation-icon.png">
                                </div>

                                <p class="mt-3">The browser will remember your login session but you need to give this PIN every time you access the account
                                </p>
                            </div>
                            <!-- <button mat-stroked-button class="primary mb-2" (click)="confirmSeed()">Confirm</button> -->
                        </div>
                    </div>
                    <div class="d-flex justify-content-between">
                      <button mat-stroked-button class="primary  solid-gradient-btn mb-2" (click)="back()">Back</button>
                      <button mat-stroked-button class="primary  solid-gradient-btn mb-2" (click)="confirmSeed()">Import</button>
                    </div>
                </div>
            </div>
        </div>
    </div>
</div>
